var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',_vm._b({scopedSlots:_vm._u([{key:"activator",fn:function({on, attrs}){return [_c(_vm.tagName,_vm._g(_vm._b({tag:"component"},'component',attrs,false),on),[_vm._t("default")],2)]}}],null,true)},"v-tooltip",_vm._d({},[_vm.position,_vm.position])),[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.dataText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }